module.exports = __webpack_public_path__ + "img/icon_mail_w.c3603426.svg";